export function DocumentText({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.1494 5.93848C14.425 5.93827 13.6588 5.93872 13.0791 5.93262H13.0723C12.2947 5.93262 11.6846 5.30997 11.6846 4.60547V2.44922C12.6927 3.4603 14.1468 4.92764 15.1494 5.93848Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.35"
        />
        <path
          d="M6.05273 2.1748H9.23242C9.25093 2.1748 9.26952 2.18165 9.28516 2.19727C9.3008 2.21291 9.30762 2.23147 9.30762 2.25V4.41797C9.30787 6.56789 11.0571 8.31713 13.207 8.31738H15.375C15.3935 8.31738 15.4121 8.3242 15.4277 8.33984C15.4433 8.35548 15.4502 8.37407 15.4502 8.39258V12.3223C15.4502 13.4953 15.0456 14.3543 14.4404 14.9229C13.8284 15.4977 12.9577 15.8252 11.9473 15.8252H6.05273C5.04234 15.8252 4.17159 15.4977 3.55957 14.9229C2.95436 14.3543 2.5498 13.4953 2.5498 12.3223V5.67773C2.5498 4.50472 2.95436 3.64569 3.55957 3.07715C4.17159 2.50233 5.04234 2.1748 6.05273 2.1748ZM5.625 11.5127C4.9872 11.5127 4.45723 12.0022 4.39355 12.624L4.3877 12.75L4.39355 12.876C4.45723 13.4978 4.9872 13.9873 5.625 13.9873H8.625C9.30529 13.9873 9.8623 13.4303 9.8623 12.75C9.8623 12.0697 9.30529 11.5127 8.625 11.5127H5.625ZM5.625 8.5127C4.9872 8.5127 4.45723 9.00223 4.39355 9.62402L4.3877 9.75L4.39355 9.87598C4.45723 10.4978 4.9872 10.9873 5.625 10.9873H10.125C10.8053 10.9873 11.3623 10.4303 11.3623 9.75C11.3623 9.06971 10.8053 8.5127 10.125 8.5127H5.625Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.35"
        />
      </svg>
    </span>
  );
}
